export default __webpack_public_path__ + "locales/ru/JavascriptSdk.json?hash=4a148e462ca46f4d6964ae206df8fb31";